<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-packagetour-menutab [isEdit]="isEdit" [nameMenu]="nameMenu" [branchofficeSlug]="branchofficeSlug"
      [checkId]="checkId">
    </app-packagetour-menutab>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Galería videos / {{item.value.description}}<span
              class="text-success"></span>
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <a class="btn btn-light d-inline" (click)="refresh()"><i class="fas fa-undo"></i> Recargar</a>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-12 m-b-10">
              <button type="button" data-toggle="modal" data-target="#openExtendsVideoTourism"
                class="btn btn-outline-info btn-extends" (click)="VideoTourismComponent.loadData()"><i
                  class="fa fa-plus m-r-5"></i>
                Seleccionar videos
              </button>

              <span class="badge badge-info bold float-right">
                <i class="fas fa-info-circle m-r-5"></i>
                No olvider guardar para aplicar cambios
              </span>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="row">
              <ng-container *ngIf="videosUpload.length > 0">
                <div class="col-lg-6 p-0" *ngFor="let item of videosUpload; let index_ = index">
                  <div class="card m-b-15">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12 col-12">
                          <ng-container *ngIf="item.is_generate_iframe">
                            <div class="content-iframe" [innerHTML]="item.iframe_video | safe"> </div>
                          </ng-container>
                          <ng-container *ngIf="!item.is_generate_iframe">
                            <span style="color: rgb(158, 155, 155);">Asegúrese de ingresar un iframe correcto</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <p class="m-t-15 m-b-10 p-l-20"><span class="bold">
                      Titulo video:</span> {{item.title}}
                      <span class="float-right f-s-12 text-danger m-r-10 pointer" (click)="removeVideo(index_)">
                        Quitar video<i class="far fa-trash-alt m-l-2" ></i>
                      </span> 
                    </p> 
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="form-group col-lg-12 form__footerBtn">
            <div class="text-right">
              <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
              <button type="submit" class="btn btn-primary waves-effect waves-light">
                <i class="far fa-save m-r-5"></i>
                Guardar
                Cambios
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-video-tourism (onselectedVideoTourismEvent)="extendsVideoTourism($event)"></app-video-tourism>
